import Breakpoints from 'breakpoints-js/dist/breakpoints.min';

const tableUtils = {

    init() {
        const $table = $('.table');
        //code to animate scroll on page load only once
        if ($table.length) {
            $('body').one('click', '.faq-item', function () {
                if ($table.is(':visible') && (Breakpoints.is('mobile') || Breakpoints.is('tablet'))) {
                    $table.addClass('table--animate-scroll');
                    setTimeout(function () {
                        $table.removeClass('table--animate-scroll');
                    }, 2000);
                }
            });

        }
    }
};

$(() => {
    tableUtils.init();
});
